export default {
  switchAccount: "Hesap Değiştir",
  login: "Giriş Yap",
  loginFirst: "Lütfen önce giriş yap",
  start: "Başlat",
  hasHistory: "Bazı soruları zaten cevapladın.",
  loadHistory: "Devam etmek ister misin?",
  cancel: "Hayır",
  confirm: "Evet",
  contact: "Bonus ödülleri kazanma şansı için iletişim bilgilerini bırak!",
  completed: "Anketi tamamladın!",
  leaveMessage: "Bonus ödülleri kazanma şansı için iletişim bilgilerini bırak!",
  enterEmail: "E-posta:",
  enterPhone: "Telefon:",
  submit: "Gönder",
  leave: "Ayrıl",
  submitted: "Gönderildi",
  thanks: "Teşekkürler!",
  opinion: "Düşüncen nedir?",
  prev: "Önceki",
  next: "Sonraki",
  unlikely: "Uzak İhtimal",
  likely: "Yüksek İhtimal",
  claimYourRewards: "Ödüllerini talep edebilirsin.",
  rewardSent: "Ödüller gönderildi.",
  checkInGame: "Lütfen onları oyunda talep et.",
  copy: "Kopyala",
  copied: "Kopyalandı!",
  selectTips: "Lütfen en iyi cevabı seç.",
  multipleTips: "Birden fazla cevap seçebilirsin.",
  leastChoose: "En fazla xxx yanıt seç",
  maxChoose: "En az xxx yanıt seç.",
  mustAnswer: "Lütfen önce mevcut soruyu cevapla.",
  mustWrite: "Lütfen bir şeyler yaz.",
  checkEmail: "Lütfen geçerli bir e-posta adresi gir.",
  checkPhone: "Lütfen geçerli bir telefon numarası gir.",
  isAnswer: "Anketi bitirdin",
  unStart: "Etkinlik mevcut değil",
  end: "Etkilnik bitti",
  server: "Sunucunu seç",
  role: "Karakter seç",
  common: "Sistem Meşgul. Daha sonra tekrar dene.",
  title: "Anket",
  titleAward: "Anket",
  leastWord: "Lütfen en az xxx karakter gir.",
  maxWord: "Karakter sınırı (xxx) aşıldı!",
  singleChoose: "Tek Cevap",
  multiChoose: "Çoklu Cevap",
  matrix: "Matris Sorusu",
  score: "Derece",
  textLimit: "(xx-yyy karakter)",
  coverGiftTitle: "Hediye Almak İçin Anketi Doldurun",
  "-20001": "Giriş yapılmadı",
  "-20002": "Gerekli parametreler eksik",
  "-20003": "Anket bulunamadı",
  "-20004": "Anket yapılandırması devam ediyor",
  "-20005": "Anket durduruldu",
  "-20006": "Anket etkinliği başlamadı",
  "-20007": "Anket etkinliği sona erdi",
  "-20008": "Zaten cevaplandı",
  "-20010": "Ödül dağıtımı başarısız",
  "-20011": "Bu anket için ödül zaten dağıtıldı",
  "-20012": "Henüz cevaplanmadı",
  "-20016": "Geçersiz oyun kimliği",
};
